<template>
    <div id="user_log">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="false"></ErrorMessages>
        <div v-if="is_initialized">
            <h1 class="ui header">
                {{ $t('ui.page_titles.user_log') }}
            </h1>
            <div v-if="is_loading" class="ui active centered inline loader"></div>
            <div v-else>
                <table class="ui table">
                    <thead>
                        <tr :class="style.width > 767 ? 'center aligned' : ''">
                            <!-- 欄位名 -->
                            <th class="eight wide">{{ $t('ui.pages.user_logs.field_name') }}</th>
                            <!-- 數值 -->
                            <th class="eight wide">{{ $t('ui.pages.user_logs.value') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr :class="style.width > 767 ? 'center aligned' : ''">
                            <!-- ID -->
                            <td>{{ $t('models.attributes.user_logs.identity') }}</td>
                            <td>{{ user_log.identity }}</td>
                        </tr>
                        <tr :class="style.width > 767 ? 'center aligned' : ''">
                            <!-- 主旨 -->
                            <td>{{ $t('models.attributes.user_logs.title') }}</td>
                            <td>{{ user_log.title }}</td>
                        </tr>
                        <tr :class="style.width > 767 ? 'center aligned' : ''">
                            <!-- 紀錄對象 -->
                            <td>{{ $t('ui.pages.user_logs.record_object') }}</td>
                            <td>{{ user_log.loggable_type }}({{ user_log.loggable_identity }})</td>
                        </tr>
                        <tr :class="style.width > 767 ? 'center aligned' : ''">
                            <!-- 操作者ID -->
                            <td>{{ $t('models.attributes.user_logs.operator_identity') }}</td>
                            <td>{{ user_log.operator_identity }}</td>
                        </tr>
                        <tr :class="style.width > 767 ? 'center aligned' : ''">
                            <!-- 動作類型 -->
                            <td>{{ $t('models.attributes.user_logs.action_type') }}</td>
                            <td>{{ user_log.action_type }}</td>
                        </tr>
                        <tr :class="style.width > 767 ? 'center aligned' : ''">
                            <!-- 日期 -->
                            <td>{{ $t('models.attributes.user_logs.created_at') }}</td>
                            <td>{{ this.human_datetime(user_log.created_at) }}</td>
                        </tr>
                        <tr :class="style.width > 767 ? 'center aligned' : ''">
                            <!-- 描述 -->
                            <td>{{ $t('models.attributes.user_logs.description') }}</td>
                            <td>{{ user_log.description || '-' }}</td>
                        </tr>

                        <tr :class="style.width > 767 ? 'center aligned' : ''">
                            <!-- 紀錄層級 -->
                            <td>{{ $t('models.attributes.user_logs.level') }}</td>
                            <td>{{ user_log.level }}</td>
                        </tr>
                        <tr>
                            <!--數值遷移 -->
                            <td :class="style.width > 767 ? 'center aligned' : ''">
                                {{ $t('models.attributes.user_logs.modified_attributes') }}
                            </td>
                            <td>
                                <pre v-html="JSONparse(user_log.modified_attributes)">
                                </pre>
                            </td>
                        </tr>
                        <tr :class="style.width > 767 ? 'center aligned' : ''">
                            <!-- 節點ID -->
                            <td>{{ $t('models.attributes.user_logs.node_identity') }}</td>
                            <td>{{ user_log.node_identity }}</td>
                        </tr>
                        <tr :class="style.width > 767 ? 'center aligned' : ''">
                            <!-- 復原紀錄？ -->
                            <td>{{ $t('models.attributes.user_logs.is_undid') }}</td>
                            <td>
                                {{
                                    user_log.is_undid
                                        ? $t('ui.pages.user_logs.yes')
                                        : $t('ui.pages.user_logs.no')
                                }}
                            </td>
                        </tr>
                        <tr :class="style.width > 767 ? 'center aligned' : ''">
                            <!-- 復原於 -->
                            <td>{{ $t('models.attributes.user_logs.undid_at') }}</td>
                            <td>{{ user_log.undid_at || '-' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "ShowUserLog",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            user_log: {},
            errors: [],
        }
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
    },
    computed: {
        style() {
            return this.$store.state.style
        },
    },
    methods: {
        async init() {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    this.is_loading = false
                    this.user_log = {}
                    this.errors = []
                    resolve()
                })
                await this.fetch_user_log()
                await new Promise(resolve => {
                    this.is_initialized = true
                })
            } catch (e) {
                switch (e) {
                    case "":
                        break
                    default:
                }
            } finally {
            }
        },
        fetch_user_log() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_log).parse(
                {
                    "log_identity": this.$route.params.identity,
                },
                ""
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.user_log = response.data.log
                        this.is_loading = false
                    } else {
                        // this.$noty.error('取得歷程失敗: ')
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.user_logs'),
                                reason: ': ' + response.data.errors
                            })
                        )
                        return Promise.reject(response.data.errors)
                    }
                })
                .catch(error => {
                    console.log(error.response)
                })
        },
        JSONparse(json) {
            if (typeof json != 'string') {
                 json = JSON.stringify(json, undefined, 2)
            }
            json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, (match) => {
                var cls = 'number'
                if (/^"/.test(match)) {
                    if (/:$/.test(match)) {
                        cls = 'key'
                    } else {
                        cls = 'string'
                    }
                } else if (/true|false/.test(match)) {
                    cls = 'boolean'
                } else if (/null/.test(match)) {
                    cls = 'null'
                }
                return `<span class="${cls}"> ${match} </span>`
            })
        }
    },
    components: {
        ErrorMessages,
    }
}
</script>

<style lang="scss" scoped>
pre {
    outline: 1px
    solid #ccc;
    padding: 5px; margin: 5px;
    .string { color: green; }
    .number { color: darkorange; }
    .boolean { color: blue; }
    .null { color: magenta; }
    .key { color: red; }
}
</style>
